import React, { useState } from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  FormGroup,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  CardGroup,
} from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import { toast } from "react-toastify";
import {
  AUTH_BASE_URL,
  BASE_LOGIN_REDIRECT_URL,
} from "../../constants/api.constants";
import CardTitle from "reactstrap/lib/CardTitle";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import PasswordVisibilityButton from "../Inputs/PasswordVisibilityButton";
import {
  PASSWORD_PATTERN,
  PASSWORD_MIN_LENGTH_PATTERN,
} from "../../Utilities/passwordPolicy";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import { saveLoginEmailPrefill } from "../../Utilities/loginEmailPrefill";

const UpdatePasswordForm = (props) => {
  const intl = useIntl();
  const [showPasswords, setShowPasswords] = useState(false);
  const redirectUrl = () => {
    window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`);
  };
  const { touched, errors, isSubmitting, values } = props;
  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <Form>
              <CardGroup>
                <Card
                  style={{ cursor: "pointer" }}
                  body
                  className="text-white bg-success py-5 d-md-down-none cursor:pointer"
                >
                  <div onClick={redirectUrl} title="Tillbaka till loginsidan">
                    <img
                      style={{ width: "100%" }}
                      src={process.env.PUBLIC_URL + "/img/LearnWareLoggo.png"}
                      className="img-avatar"
                      alt="LearnWARE logga in"
                    />
                  </div>
                </Card>
                <Card>
                  <CardHeader>
                    <CardTitle
                      className="h3"
                      style={{ marginBottom: "0.25rem" }}
                    >
                      <FormattedMessage id="Views.UpdatePassword.Header" />
                      <i
                        onClick={redirectUrl}
                        title="Tillbaka till loginsidan"
                        style={{ cursor: "pointer" }}
                        className="fa fa-close float-end close"
                      />
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Label.Password" />
                      </Label>
                      <Field
                        hidden
                        type="text"
                        name="email"
                        autoComplete="username"
                      />
                      <div className="position-relative">
                        <Field
                          autoFocus={true}
                          className={`form-control password-input ${
                            errors.password && touched.password && "is-invalid"
                          }`}
                          type={showPasswords ? "text" : "password"}
                          name="password"
                          autoComplete="new-password"
                          placeholder={intl.formatMessage({
                            id: "signin.placeholder.password",
                          })}
                        />
                        {(values.password || values.repeatpassword) && (
                          <PasswordVisibilityButton
                            visible={showPasswords}
                            onToggle={() => setShowPasswords((show) => !show)}
                          />
                        )}
                      </div>
                      {errors.password && touched.password && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Label.RepeatPassword" />
                      </Label>
                      <Field
                        className={`form-control ${
                          errors.repeatpassword &&
                          touched.repeatpassword &&
                          "is-invalid"
                        }`}
                        type={showPasswords ? "text" : "password"}
                        name="repeatpassword"
                        autoComplete="new-password"
                        placeholder={intl.formatMessage({
                          id: "Views.StudentSelfRegistration.SelfRegistrationForm.Input.RepeatPassword",
                        })}
                      />
                      {errors.repeatpassword && touched.repeatpassword && (
                        <div className="invalid-feedback">
                          {errors.repeatpassword}
                        </div>
                      )}
                    </FormGroup>

                    <Button
                      type="submit"
                      color="success"
                      block
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.ButtonPressed" />
                      ) : (
                        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Button" />
                      )}
                    </Button>
                  </CardBody>
                </Card>
              </CardGroup>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues({ password, repeatpassword }) {
    // Add information with request
    return {
      password: password || "",
      repeatpassword: repeatpassword || "",
    };
  },
  validationSchema: Yup.object().shape({
    password: Yup.string()
      .required(
        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Password" />,
      )
      .matches(PASSWORD_PATTERN, {
        message: (
          <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Format" />
        ),
        excludeEmptyString: true,
      })
      .matches(PASSWORD_MIN_LENGTH_PATTERN, {
        message: (
          <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Length" />
        ),
      }),
    repeatpassword: Yup.string()
      .oneOf(
        [Yup.ref("password")],
        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Diff" />,
      )
      .required(
        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.RepPassword" />,
      ),
  }),

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    //add student
    axios
      .post(`${AUTH_BASE_URL}/token/updatepassword`, {
        token: props.token,
        newPassword: values.password,
      })
      .then((response) => {
        // 903: länken gick ut eller användes medan formuläret var öppet.
        if (response.data.code === "903") {
          props.onLinkExpired();
          return;
        }
        if (response.data.code === "999") {
          toast.success(
            <FormattedMessage
              id={
                props.isFromApp
                  ? "Views.UpdatePassword.UpdatePasswordForm.SuccessForApp"
                  : "Views.UpdatePassword.UpdatePasswordForm.Success"
              }
            />,
            {
              position: "top-right",
              closeOnClick: true,
              pauseOnHover: true,
              autoClose: 3000,
              onClose: () => {
                if (props.isFromApp) {
                  // Hash-rutt i samma app, så basadressen behöver inte vara känd här.
                  window.location.replace("#/password/redirectToApp");
                  return;
                }
                saveLoginEmailPrefill(response.data.email);
                window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`);
              },
            },
          );
        } else if (response.data.code === "902") {
          toast.warning(
            <FormattedMessage id="Views.UpdatePassword.UpdatePasswordForm.Exists" />,
            TOAST_CONFIG,
          );
        } else {
          toast.warning(
            <FormattedMessage id="GenericApiError" />,
            TOAST_CONFIG,
          );
        }
        resetForm();
      })
      .catch((err) => {
        setErrors({
          password: formatServiceError(props.intl, err?.response?.data),
        });
      })
      .finally(() => setSubmitting(false));
  },
})(UpdatePasswordForm);

const UpdatePasswordFormWithIntl = (props) => {
  const intl = useIntl();

  return <FormikForm {...props} intl={intl} />;
};

export default UpdatePasswordFormWithIntl;
